import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type DivisionListQueryParams = Parameters<typeof SSF.api.divisionsList>[0];

export const keys = createQueryKeySet<DivisionListQueryParams>('division');

export function useDivisionListQuery(params?: DivisionListQueryParams, enabled = true) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.divisionsList(params);
      return data;
    },
    queryKey: keys.list(params),
    enabled,
  });
}

export function useDivisionDetailQuery(id: number) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.divisionsRetrieve(id);
      return data;
    },
    queryKey: keys.detail(id),
  });
}
